export const defaultProviderForm = {
  name: '',
  title: '',
  organization: '',
  email: '',
  phone: '',
  fax: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  postalCode: '',
  npi: ''
};

export const defaultGrantForm = {
  providerId: '',
  purpose: '',
  expiryDate: '',
  accessLevel: 'READ',
  allRecords: true,
  recordIds: []
};

export const defaultDestinationForm = {
  name: '',
  title: '',
  organization: '',
  email: '',
  phone: '',
  fax: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  postalCode: ''
};

export const RECORD_TYPE_OPTIONS = [
  { value: 'COMPLETE', label: 'Complete Medical Record' },
  { value: 'LAB_RESULTS', label: 'Lab Results' },
  { value: 'IMAGING', label: 'Imaging/Radiology' },
  { value: 'CONSULTATION', label: 'Consultation Notes' },
  { value: 'PRESCRIPTIONS', label: 'Prescriptions' },
  { value: 'IMMUNIZATIONS', label: 'Immunizations' },
  { value: 'SURGICAL', label: 'Surgical/Procedure Records' },
  { value: 'DISCHARGE', label: 'Discharge Summary' },
  { value: 'OTHER', label: 'Other' }
];

/** Purpose: Formats date values for UI display. Inputs: value. Output: formatted date string. */
export function formatDate(value) {
  if (!value) return 'N/A';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'N/A';
  return date.toLocaleDateString();
}

/** Purpose: Normalizes text for safe loose matching. Inputs: value. Output: normalized string. */
export function normalize(value) {
  return String(value || '').trim().toLowerCase();
}

/** Purpose: Builds a future expiry date string. Inputs: daysFromNow. Output: YYYY-MM-DD date string. */
export function buildExpiryDate(daysFromNow) {
  return new Date(Date.now() + daysFromNow * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
}

/** Purpose: Creates a mutable provider form object from provider data. Inputs: provider. Output: provider form object. */
export function mapProviderToForm(provider) {
  return {
    name: provider?.name || '',
    title: provider?.title || '',
    organization: provider?.organization || '',
    email: provider?.email || '',
    phone: provider?.phone || '',
    fax: provider?.fax || '',
    addressLine1: provider?.addressLine1 || '',
    addressLine2: provider?.addressLine2 || '',
    city: provider?.city || '',
    state: provider?.state || '',
    postalCode: provider?.postalCode || ''
  };
}

/** Purpose: Determines whether a record likely originated from a provider. Inputs: record, provider. Output: boolean. */
export function isRecordFromProvider(record, provider) {
  const recordProvider = normalize(record.provider);
  const providerName = normalize(provider.name);
  const providerOrganization = normalize(provider.organization);
  if (!recordProvider) return false;
  if (providerName && (recordProvider === providerName || recordProvider.includes(providerName) || providerName.includes(recordProvider))) {
    return true;
  }
  if (providerOrganization && (recordProvider === providerOrganization || recordProvider.includes(providerOrganization) || providerOrganization.includes(recordProvider))) {
    return true;
  }
  return false;
}

/** Purpose: Formats a provider address for compact display. Inputs: provider. Output: address string. */
export function formatProviderAddress(provider) {
  const line1 = provider.addressLine1?.trim();
  const line2 = provider.addressLine2?.trim();
  const cityStatePostal = [provider.city, provider.state, provider.postalCode]
    .map((part) => (part || '').trim())
    .filter(Boolean)
    .join(', ');
  const pieces = [line1, line2, cityStatePostal].filter(Boolean);
  return pieces.join(' • ');
}
